// extracted by mini-css-extract-plugin
module.exports = {"image":"appetini-module--image--29tez"};